import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=5ba69a82&scoped=true&"
import script from "./DeliveryList.vue?vue&type=script&lang=js&"
export * from "./DeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=5ba69a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba69a82",
  null
  
)

export default component.exports